import type { TextProps } from "@amzn/storm-ui";
import { Icon, Text } from "@amzn/storm-ui";
import React from "react";

import { StatusTextState } from "../../types/common";

import { DivFlexAlignCenter } from "./styled.components";

export interface StatusTextWithLoadStateProps extends TextProps {
    activeText: string;
    inactiveText: string;
    status: StatusTextState;
    loadingText?: string;
}

export const StatusTextWithLoadState: React.FunctionComponent<
    StatusTextWithLoadStateProps
> = (props) => {
    const { status, loadingText, activeText, inactiveText, id } = props;
    const hasLoadingText = !!loadingText;

    return (
        <DivFlexAlignCenter data-testid={id}>
            {status === StatusTextState.LOADING ? (
                <>
                    <Icon
                        type="spinner"
                        size="base"
                        id={`${id}-loading-icon`}
                        data-testid={`${id}-loading-icon`}
                    />
                    {hasLoadingText && (
                        <Text
                            data-testid={`${id}-loading-text`}
                            id={`${id}-loading-text`}
                            color="secondary"
                        >
                            {loadingText}
                        </Text>
                    )}
                </>
            ) : status === StatusTextState.ACTIVE ? (
                <>
                    <Icon
                        type="check"
                        size="base"
                        style={{ color: "green" }}
                        id={`${id}-active-icon`}
                        data-testid={`${id}-active-icon`}
                    />
                    <Text
                        id={`${id}-active-text`}
                        data-testid={`${id}-active-text`}
                        style={{ color: "green" }}
                    >
                        {activeText}
                    </Text>
                </>
            ) : (
                <>
                    <Icon
                        type="close"
                        size="base"
                        style={{ color: "grey" }}
                        id={`${id}-inactive-icon`}
                        data-testid={`${id}-inactive-icon`}
                    />
                    <Text
                        id={`${id}-inactive-text`}
                        data-testid={`${id}-inactive-text`}
                        style={{ color: "grey" }}
                    >
                        {inactiveText}
                    </Text>
                </>
            )}
        </DivFlexAlignCenter>
    );
};
